import { ReactNode } from 'react';

import { Typography } from '@braskai/ui-kit';

import { CardMedia, Stack, StackProps } from '@mui/material';

import TeamspaceImage from '@/shared/assets/images/teamspace-banner.png';

type TeamSpaceBannerProps = {
  title?: string;
  children?: ReactNode;
  color?: 'error' | 'primary';
  dataTestId?: string;
  description?: string;
  isImage?: boolean;
} & StackProps;

export const TeamspaceBanner = ({
  title,
  children,
  color,
  dataTestId,
  description,
  isImage,
  onClick,
  ...props
}: TeamSpaceBannerProps) => {
  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette[color || 'primary'][50],
        borderRadius: 8,
        cursor: onClick ? 'pointer' : 'default',
        padding: '10px 6px 10px 10px',
        whiteSpace: 'normal',
        width: '100%',
      })}
      data-testid={dataTestId}
      gap={4}
      onClick={onClick}
      {...props}
    >
      {isImage && <CardMedia alt={title} component="img" src={TeamspaceImage} sx={{ height: 24, width: 60 }} />}
      {title && (
        <Typography color="grey.900" variant="caption-1-md">
          {title}
        </Typography>
      )}
      {description && (
        <Typography color="grey.900" variant="caption-1">
          {description}
        </Typography>
      )}
      {children}
    </Stack>
  );
};
